import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const CommonAvatarStyled = styled(Box)`
  position: relative;

  .MuiAvatar-root {
    height: ${({ size }) => `${size || 64}px`};
    width: ${({ size }) => `${size || 64}px`};
  }

  .badge-icon {
    position: absolute;
    bottom: 0;
    right: 0;
    height: ${({ styleBadgeIcon }) => styleBadgeIcon?.height || '24px'};
  }
`;

const StyledFrameImg = styled('img')`
  display: block;
  border-radius: 50%;
  z-index: 10;
  position: absolute;
  top: ${({ top }) => top || '57%'};
  left: 50%;
  transform: translate(-50%, -50%) ${({ transform }) => transform};
`;

export { CommonAvatarStyled, StyledFrameImg };
